<script setup lang="ts">
import useAppStore from '@/stores/app';
import { debounce } from 'lodash';

// Instances
const appStore = useAppStore();

// Methods
const resizeEventListener = debounce((): void => {
    appStore.updateWindowWidth(window.innerWidth);
    appStore.updateWindowHeight(window.innerHeight);
}, 250, {maxWait: 500});

// Hooks
onBeforeMount(() => {
    resizeEventListener();

    window.addEventListener('resize', resizeEventListener);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', resizeEventListener);
});

onErrorCaptured(error => {
    if ((import.meta.env.VITE_APP_ENV === 'development') || (import.meta.env.VITE_APP_ENV === 'production')) {
        if ((error.name === 'TypeError') && (error.message.indexOf('dynamically imported module') !== -1)) {
            window.location.reload();

            return false;
        }
    }

    return true;
});
</script>

<template>
    <RouterView/>
</template>

<style scoped>

</style>
